export default "__VITE_ASSET__DZDFTiRP__"